import firebaseInit from "./firebaseInit";
import { updateProfile,GoogleAuthProvider, getAuth, signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";

const FirebaseConnect = () => {
    firebaseInit();
    const [user, setUser] = useState({});
    const [error, setError] = useState('');
    const [isLoading,setIsLoading] = useState(true);
    const GoogleProvider = new GoogleAuthProvider();
    const auth = getAuth();

   
    //google login
    const GoogleLogin = () => {
        setIsLoading(true);
        signInWithPopup(auth, GoogleProvider)
            .then((result) => {
                setUser(result.user);
                console.log(result.user);
            }).catch((error) => {
                setError(error.message);
            });
            setIsLoading(false);
    }

    //update Profile
    const UpdateGoogleProfile = (phone) => {
        updateProfile(auth.currentUser, {
            displayName: user.displayName, photoURL: user.photoURL,
            phoneNumber:phone
        }).then(() => {
            console.log("Profile Updated");
        }).catch((error) => {
            console.log(error);
            setError(error);
        });
    }


    //logOut
    const LogOut = () => {
        setIsLoading(true);
        signOut(auth).then(() => {
            setUser({});
        }).catch((error) => {
            setError(error);
        });
        setIsLoading(false);
    }


    //manage user's login state
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            setIsLoading(true);
            if (user) {
                setUser(user);
            } else {
                setUser({});
            }
            setIsLoading(false);
        });

    }, [])

    return {
        setUser,
        user,
        error,
        GoogleLogin,
        LogOut,
        UpdateGoogleProfile,
        isLoading,
        auth,
        GoogleProvider,
        signInWithPopup
    }

}

export default FirebaseConnect;